module.exports = __webpack_public_path__ + "static/media/task-new-hire.33de2cc1.svg";